import React from 'react';
import { SubtitleEditorList } from './SubtitleEditorList';

interface VideoTextListProps {
    textListRef: React.RefObject<HTMLDivElement | null>;
    listProps: any;
}

export const VideoTextList: React.FC<VideoTextListProps> = ({ textListRef, listProps }) => {
    return (
        <div className="text-list" ref={textListRef}>
            <SubtitleEditorList {...listProps} />
        </div>
    );
};
